import React from "react";
import AppButton from "./layout/app-button";
import eventTrack from "../lib/event-track";

const ShareButton = ({ articleTitle, color = "highlight" }) => (
  <AppButton
    colors={{
      default: {
        background: color,
        text: "white",
      },
    }}
    icon="share"
    onClick={() => {
      if (navigator.share) {
        navigator
          .share({
            title: articleTitle,
            text: `${articleTitle} - ${window.location.href}`,
            url: window.location.href,
          })
          .then(() => "noop")
          .catch(() => "noop");
      } else {
        window.open(
          `mailto:?subject=${articleTitle}&body=${window.location.href}`
        );
      }
      eventTrack("Article Shared", {
        props: {
          url: window.location.pathname,
        },
      });
    }}
  >
    Share <span sx={{ display: ["none", "inline-block"] }}>Article</span>
  </AppButton>
);

export default ShareButton;
